import '../styles/clientes.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import logoHonda from '../assets/logo-honda.svg';
import paseo from '../assets/paseo.svg';
import yoizen from '../assets/yoizen.svg';
import flex from '../assets/flexibility.svg';
import energy from '../assets/energy.svg';
import fravega from '../assets/fravegatech.svg';

export const Clientes = () => {
	const logos = [
	logoHonda,
	paseo,
	yoizen,
	flex,
	energy,
	fravega,
  ];

	const CustomNextArrow = (props: any) => {
		const { className, style, onClick } = props;
		return (
			<div
				className={className}
				style={{ ...style, display: 'block', color: 'black' }}
				onClick={onClick}
			/>
		);
	};

	const CustomPrevArrow = (props: any) => {
		const { className, style, onClick } = props;
		return (
			<div
				className={className}
				style={{ ...style, display: 'block', color: 'black' }}
				onClick={onClick}
			/>
		);
	};

	const settings = {
		dots: true,
		infinite: true,
		speed: 700,
		slidesToShow: window.innerWidth <= 480 ? 1 : window.innerWidth <= 768 ? 2 : window.innerWidth <= 1024 ? 3 : 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		arrows: true,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
	  };

  return (
	<div className='clientes'>
	  <div className='clientes-container'>
				<h2 data-aos="fade-down" data-aos-delay="200">Confían en nosotros</h2>
				<Slider {...settings} data-aos="fade-down" data-aos-delay="400">
		  {logos.map((logo, index) => (
			<div key={index} className='logo-item'>
			  <img src={logo} alt={`Cliente ${index + 1}`} className='logo-clientes'/>
			</div>
		  ))}
		</Slider>
			</div>
	</div>
  )
}
